import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

export const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" className="link" to="/">
        Mooringmate
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};
